import { render } from "./InProgress.vue?vue&type=template&id=52e5a5e4&scoped=true"
import script from "./InProgress.vue?vue&type=script&lang=js"
export * from "./InProgress.vue?vue&type=script&lang=js"

import "./InProgress.vue?vue&type=style&index=0&id=52e5a5e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5a5e4"]])

export default __exports__